import { VMenu as _, VBtn as r, VAvatar as z, VIcon as j, VCard as c, VList as f, VListItem as m, VListItemAction as p, VRow as L, VOverlay as O, VCardTitle as x, VCardText as C, VDivider as T, VSlider as S } from "vuetify/lib";
import { defineComponent as w, ref as N, computed as E, watchEffect as b } from "vue";
const k = /* @__PURE__ */ w({
  __name: "LoginMenu",
  props: {
    userInfo: null,
    oauthClient: null,
    logout: null,
    fetchUserInfo: null
  },
  setup(o) {
    const t = o, e = N(!1), n = N(""), s = E(() => t.userInfo !== null ? `${t.userInfo.first_name[0] || ""}${t.userInfo.last_name[0] || ""}` : "");
    b(() => {
      e.value && (n.value = window.location.href);
    });
    async function g() {
      await t.logout(), window.location.href = "https://multinet.app";
    }
    function u() {
      t.oauthClient.redirectToLogin();
    }
    return t.fetchUserInfo(), { __sfc: !0, props: t, menu: e, location: n, userInitials: s, logout: g, login: u };
  }
}), v = "data:image/svg+xml;base64,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";
function d(o, t, e, n, s, g, u, l) {
  var i = typeof o == "function" ? o.options : o;
  t && (i.render = t, i.staticRenderFns = e, i._compiled = !0), n && (i.functional = !0), g && (i._scopeId = "data-v-" + g);
  var M;
  if (u ? (M = function(a) {
    a = a || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !a && typeof __VUE_SSR_CONTEXT__ < "u" && (a = __VUE_SSR_CONTEXT__), s && s.call(this, a), a && a._registeredComponents && a._registeredComponents.add(u);
  }, i._ssrRegister = M) : s && (M = l ? function() {
    s.call(
      this,
      (i.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : s), M)
    if (i.functional) {
      i._injectStyles = M;
      var I = i.render;
      i.render = function(y, A) {
        return M.call(A), I(y, A);
      };
    } else {
      var D = i.beforeCreate;
      i.beforeCreate = D ? [].concat(D, M) : [M];
    }
  return {
    exports: o,
    options: i
  };
}
var h = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(_, { attrs: { "offset-x": "" }, scopedSlots: t._u([{ key: "activator", fn: function({ on: s }) {
    return [e(r, t._g({ attrs: { icon: "" } }, s), [e(z, { attrs: { color: "grey lighten-4", size: "36px" } }, [t.userInfo ? e("span", [t._v(t._s(n.userInitials))]) : e(j, { attrs: { color: "grey" } }, [t._v(" mdi-account-circle ")])], 1)], 1)];
  } }]), model: { value: n.menu, callback: function(s) {
    n.menu = s;
  }, expression: "menu" } }, [e(c, [e(f, [e(m, { staticClass: "sign-in-item" }, [e(p, [t.userInfo ? e(r, { attrs: { dark: "", color: "grey darken-3" }, on: { click: n.logout } }, [t._v(" Log out ")]) : e(r, { staticClass: "google-sign-in", attrs: { dark: "", ripple: !1 }, on: { click: n.login } }, [e("span", { staticClass: "google-logo" }, [e("img", { attrs: { alt: "Google", src: v } })]), e("span", { staticClass: "button-text" }, [t._v(" Sign in with Google ")])])], 1)], 1)], 1)], 1)], 1);
}, U = [], B = /* @__PURE__ */ d(
  k,
  h,
  U,
  !1,
  null,
  "fe6bdc84",
  null,
  null
);
const H = B.exports;
async function G(o, t, e, n, s, g, u, l) {
  const i = `let nodes = (FOR n in [${e}][**] LIMIT ${t} RETURN n) let edges = (FOR e in ${n} filter e._from in nodes[**]._id && e._to in nodes[**]._id RETURN e)
      RETURN {"nodes": nodes[**], edges}`;
  let M = { nodes: [], edges: [] };
  try {
    M = (await l.aql(o, { query: i, bind_vars: {} }))[0];
  } catch (I) {
    I.status === 400 ? g({
      message: I.statusText,
      href: "https://multinet.app"
    }) : g({
      message: "An unexpected error ocurred",
      href: "https://multinet.app"
    });
  } finally {
    s.message === "The network you are loading is too large" && typeof M > "u" && g({
      message: "There was a network issue when getting data",
      href: `./?workspace=${o}&network=${u}`
    });
  }
  return M;
}
const Q = /* @__PURE__ */ w({
  __name: "NetworkSubsetter",
  props: {
    workspaceName: null,
    minSubsetSize: null,
    maxSubsetSize: null,
    nodeTableNames: null,
    edgeTableName: null,
    loadError: null,
    setLoadError: null,
    networkName: null,
    api: null
  },
  emits: ["networkUpdated"],
  setup(o, { emit: t }) {
    const e = o, n = N(0);
    async function s() {
      const g = await G(
        e.workspaceName,
        n.value,
        e.nodeTableNames,
        e.edgeTableName,
        e.loadError,
        e.setLoadError,
        e.networkName,
        e.api
      );
      t("networkUpdated", g);
    }
    return { __sfc: !0, props: e, emit: t, subsetAmount: n, subset: s };
  }
});
var Z = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", [e(L, { attrs: { align: "center", justify: "center" } }, [e(O, { attrs: { absolute: "" } }, [e(c, [e(x, [t._v("Network Too Large")]), e(C, [t._v(" The network you are loading is too large to visualize in this tool. Please select one of the following options: ")]), e(c, [e(T), e(C, [e("div", [t._v("Choose a random subset of nodes")]), e(S, { attrs: { max: t.maxSubsetSize, min: t.minSubsetSize, step: "10", ticks: "", "thumb-label": "", "thumb-color": "primary" }, scopedSlots: t._u([{ key: "append", fn: function() {
    return [e(r, { staticClass: "mt-0 pt-0", attrs: { color: "primary" }, on: { click: n.subset } }, [t._v("subset")])];
  }, proxy: !0 }]), model: { value: n.subsetAmount, callback: function(s) {
    n.subsetAmount = s;
  }, expression: "subsetAmount" } })], 1), e(T)], 1)], 1)], 1)], 1)], 1);
}, Y = [], R = /* @__PURE__ */ d(
  Q,
  Z,
  Y,
  !1,
  null,
  null,
  null,
  null
);
const W = R.exports;
export {
  H as LoginMenu,
  W as NetworkSubsetter
};
